export default __webpack_public_path__ + "static/media/sidechair.a8e30e82.jpg";